//REGISTER
export const POST_FAKE_REGISTER = "/auth/signup";

//LOGIN
export const LOGIN = "/api/v1/Auth/Login";
// export const POST_FAKE_JWT_LOGIN = "/post-jwt-login";
// export const POST_FAKE_PASSWORD_FORGET = "/auth/forgot-password";
// export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
// export const SOCIAL_LOGIN = "/social-login";

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile";
export const POST_EDIT_PROFILE = "/user";

//CALENDER
// export const GET_EVENTS = "/events";
// export const GET_CATEGORIES = "/categories";
// export const GET_UPCOMMINGEVENT = "/upcommingevents";
// export const ADD_NEW_EVENT = "/add/event";
// export const UPDATE_EVENT = "/update/event";
// export const DELETE_EVENT = "/delete/event";

// Users
export const GET_USER_DATA = "/api/v1/User/Get?Id=";











